import { connect, mapProps } from '@formily/vue'
import OriginalCollapseTable from './CollapseTable.vue'

const CollapseTable = connect(OriginalCollapseTable, mapProps({ readOnly: 'readonly' }))

export default CollapseTable
